import { FileText } from 'lucide-react';
import SEOHead from '@/components/SEOHead';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead
        title="Gizlilik Politikası | TesisKirala.com"
        description="TesisKirala.com Gizlilik Politikası. Kişisel verilerinizin nasıl toplandığı, kullanıldığı ve korunduğu hakkında bilgi."
        canonicalPath="/gizlilik-politikasi"
      />
      
      {/* Hero */}
      <section className="bg-emerald-800 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-emerald-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <FileText className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Gizlilik Politikası
          </h1>
          <p className="text-emerald-100">
            Son güncelleme: Aralık 2024
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-slate max-w-none">
            
            <h2>1. Giriş</h2>
            <p>
              AVRASYA SPORTİF FAALİYETLER ("TesisKirala.com", "biz", "bizim") olarak, gizliliğinize önem veriyoruz. 
              Bu Gizlilik Politikası, web sitemizi ve hizmetlerimizi kullandığınızda kişisel verilerinizi nasıl 
              topladığımızı, kullandığımızı, paylaştığımızı ve koruduğumuzu açıklamaktadır.
            </p>

            <h2>2. Topladığımız Bilgiler</h2>
            <h3>2.1. Doğrudan Sağladığınız Bilgiler</h3>
            <ul>
              <li><strong>Hesap Bilgileri:</strong> Ad, soyad, e-posta adresi, telefon numarası</li>
              <li><strong>Fatura Bilgileri:</strong> Fatura adresi, vergi numarası, şirket bilgileri</li>
              <li><strong>Ödeme Bilgileri:</strong> Kredi kartı bilgileri (güvenli ödeme sağlayıcısı aracılığıyla)</li>
              <li><strong>İletişim Bilgileri:</strong> Destek talepleriniz ve mesajlarınız</li>
            </ul>

            <h3>2.2. Otomatik Toplanan Bilgiler</h3>
            <ul>
              <li><strong>Cihaz Bilgileri:</strong> IP adresi, tarayıcı türü, işletim sistemi</li>
              <li><strong>Kullanım Verileri:</strong> Ziyaret edilen sayfalar, tıklama verileri, site içi arama sorguları</li>
              <li><strong>Çerezler:</strong> Oturum çerezleri ve analiz çerezleri</li>
            </ul>

            <h2>3. Bilgilerin Kullanım Amaçları</h2>
            <p>Topladığımız bilgileri aşağıdaki amaçlarla kullanıyoruz:</p>
            <ul>
              <li>Rezervasyon işlemlerinizi gerçekleştirmek</li>
              <li>Hesabınızı oluşturmak ve yönetmek</li>
              <li>Müşteri desteği sağlamak</li>
              <li>Ödeme işlemlerini gerçekleştirmek</li>
              <li>Size önemli bildirimleri göndermek</li>
              <li>Hizmetlerimizi geliştirmek</li>
              <li>Yasal yükümlülüklerimizi yerine getirmek</li>
            </ul>

            <h2>4. Bilgi Paylaşımı</h2>
            <p>Kişisel bilgilerinizi aşağıdaki durumlar dışında üçüncü taraflarla paylaşmıyoruz:</p>
            <ul>
              <li><strong>Tesis Sahipleri:</strong> Rezervasyon yaptığınızda, ilgili tesis sahibi ile iletişim bilgilerinizi paylaşırız</li>
              <li><strong>Ödeme İşleyicileri:</strong> Ödeme işlemlerinizi güvenli bir şekilde gerçekleştirmek için</li>
              <li><strong>Yasal Gereklilikler:</strong> Yasal bir zorunluluk olduğunda veya haklarımızı korumak için</li>
            </ul>

            <h2>5. Veri Güvenliği</h2>
            <p>
              Kişisel verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz:
            </p>
            <ul>
              <li>SSL/TLS şifreleme</li>
              <li>Güvenli sunucu altyapısı</li>
              <li>Düzenli güvenlik denetimleri</li>
              <li>Erişim kontrolü ve kimlik doğrulama</li>
            </ul>

            <h2>6. Haklarınız</h2>
            <p>KVKK kapsamında aşağıdaki haklara sahipsiniz:</p>
            <ul>
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>İşlenmiş veriler hakkında bilgi talep etme</li>
              <li>Verilerin düzeltilmesini isteme</li>
              <li>Verilerin silinmesini talep etme</li>
              <li>Verilerin aktarılmasını isteme</li>
            </ul>

            <h2>7. Çerez Politikası</h2>
            <p>
              Web sitemizde çerezler kullanıyoruz. Çerezlerin nasıl kullanıldığı hakkında daha fazla bilgi için 
              <a href="/cerez-politikasi" className="text-emerald-700 hover:underline">Çerez Politikası</a> sayfamızı ziyaret edin.
            </p>

            <h2>8. Değişiklikler</h2>
            <p>
              Bu Gizlilik Politikası'nı zaman zaman güncelleyebiliriz. Önemli değişiklikler yapıldığında 
              sizi e-posta veya site üzerinden bilgilendireceğiz.
            </p>

            <h2>9. İletişim</h2>
            <p>
              Gizlilik politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
            </p>
            <ul>
              <li><strong>E-posta:</strong> tesiskirala@gmail.com</li>
              <li><strong>Adres:</strong> Altıntepe Mah. Galipbey Cad. Dış Kapı No: 119/A Dükkân No: 2 Esen Apt., Maltepe/İSTANBUL</li>
            </ul>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
